var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"recommended-products-more fontsize-mini text-black px-3  mt-4 d-inline-block",attrs:{"to":_vm.to}},[_c('span',[_vm._v(" "+_vm._s(_vm.title)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }